import { Link } from 'react-router-dom';
import { CircleQuestionMark } from 'lucide-react';

/**
 * Small "?" that deep-links to a help article.
 *
 * Drop next to anything that reliably prompts "what is this?" — the
 * Safe-to-Spend figure, the VAT warning, the pots. Cheaper and far more robust
 * than an anchored tour step, because it is just a link: it can't get out of
 * sync with the layout, and it's there on the day someone actually wonders
 * rather than only during a first run they clicked past.
 */
export const HelpHint = ({
    slug,
    label = 'What is this?',
    className = '',
}: {
    slug: string;
    label?: string;
    className?: string;
}) => (
    <Link
        to={`/help/${slug}`}
        aria-label={label}
        title={label}
        className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-fg-4 hover:text-gold hover:bg-card transition-colors shrink-0 ${className}`}
    >
        <CircleQuestionMark className="w-4 h-4" strokeWidth={2} />
    </Link>
);
